import { useMutation, useQuery } from "@tanstack/react-query";

import { useApplication } from "@olist/microfrontend";

import { supportTicketsService } from "./services";

export function useNewTicket() {
  const context = useApplication();
  const accessToken = context?.accessToken || "";

  return useMutation({
    mutationFn: ({ param, payload }: { payload: any; param?: string }) =>
      supportTicketsService.createNewTicket(accessToken, payload, param),
  });
}

export function useGetSupportUserStatus() {
  const context = useApplication();
  const accessToken = context?.accessToken || "";

  return useQuery({
    queryKey: ["support-user-status"],
    queryFn: () => supportTicketsService.getSupportUserStatus(accessToken),
    retry: 1,
  });
}
